import type { FC, ReactNode } from "react"

import { Page404 } from "@/components/nav/page404"
import { useActiveOrganization, useAuthentication } from "@/contexts"
import { useFlags } from "@/services/feature"

interface LabsGuardProps {
  children: ReactNode
}

/**
 * Admin and admin reader always reach Labs.
 * Every other signed-in user needs the labs flag.
 */
export const LabsGuard: FC<LabsGuardProps> = ({ children }) => {
  const { activeOrganization } = useActiveOrganization()
  const { isAdminUser } = useAuthentication()
  const { flagsIsFetched, ...flags } = useFlags()

  if (!activeOrganization) {
    return null
  }

  if (isAdminUser) {
    return children
  }

  if (!flagsIsFetched) {
    return null
  }

  if (flags.labs) {
    return children
  }

  return <Page404 />
}
